import React, { useEffect } from 'react';
import ClearingMemberAccountsContainer from '../ClearingMemberAccounts/ClearingMemberAccountsContainer';
import BalancesGrid, {
  BALANCES_GRID_NAME,
} from 'components/agGrid/ClearingAccounts/Balances/BalancesGrid';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { assetTypes } from '../../actions/utilActions';

const BalancesIndexContainer = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(assetTypes());
  }, [dispatch]);

  return (
    <ClearingMemberAccountsContainer
      balances
      gridOpts={{
        gridName: BALANCES_GRID_NAME,
        GridComponent: BalancesGrid,
      }}
    />
  );
};

export default BalancesIndexContainer;
